import React, { useEffect, useState, Fragment, useContext } from 'react';
import {	Stack, TableRow, Typography, TextField, Button, Link } from '@mui/material';
import Subtitle from '../ui/Subtitle';
import Selector from '../ui/Selector';
import { backendFetch, backendPostWithJson, backendPutWithJson } from '../../backend/backend';
import { DatePicker } from '@mui/lab';
import { tokenContext } from '../TokenProvider';
import { DateTime } from 'luxon';
import { TSCell, TSTable } from '../ui/TableStructure';
import FixtureGenerationRules from '../rules/FixtureGenerationRules';

const EditFixturesPage = () => {
	const [fixtures,setFixtures]=useState([]);
	const [players,setPlayers]=useState([]);
	const [update,setUpdate]=useState(false);
	const [newFixtureDate,setNewFixtureDate]=useState();
	const [newFixtureHost,setNewFixtureHost]=useState('');
	const {token,dropAdmin}=useContext(tokenContext);
	const [activeSeason,setActiveSeason]=useState();

	const forceUpdate=()=>{
		setUpdate((update)=>!update);
	}

	const forceDateInSeason=(date)=>{
		const dateString=typeof(date)==='string';
		if (!dateString)
			date=date.toISODate();
		console.log(typeof(date));
		if (date<activeSeason.startDate)
			date=activeSeason.startDate;
		if (date>activeSeason.endDate)
			date=activeSeason.endDate;
		if (!dateString)
			date=DateTime.fromISO(date);
		return date;
	}

	useEffect(()=>{
		async function fetchData() {
			const players=await backendFetch('players?active=true');
			setPlayers(players.map((p)=>p.name));
			const seasons=await backendFetch('seasons');
			const activeSeason=seasons.filter((s)=>s.status==='active')[0];
			setActiveSeason(activeSeason);
			const fixtures=await backendFetch(`fixtures?season=active&token=${token}`);
			var last=undefined;
			fixtures.forEach((f)=>{
				f.prevDate=f.date;
				f.prevHost=f.host
				if (!last || f.date>last)
					last=f.date;
			});
			if (!last && activeSeason)
				setNewFixtureDate(activeSeason.startDate);
			else {
				var nextFixture=DateTime.fromISO(last).plus({months:1});
				nextFixture=nextFixture.minus({days:nextFixture.day-1});	// Set to first of following month
				setNewFixtureDate(nextFixture);
			}
			setFixtures(fixtures);
		}
		fetchData();
	},[update,token]);

	const setFixtureDate=(index,value)=>{
		setFixtures(fixtures => {
			fixtures[index].date=forceDateInSeason(value.toISODate());
			return[...fixtures];
		})
	}

	const setFixtureHost=(index,value)=>{
		setFixtures(fixtures => {
			fixtures[index].host=value;
			return[...fixtures];
		})
	}

	const addFixture=async ()=>{
		const success=await backendPostWithJson(token,dropAdmin,'fixtures',{
			date:newFixtureDate.toISODate(),
			host:newFixtureHost
		});
		if (success) {
			console.log("addFixture success");
			setNewFixtureHost('');
			forceUpdate();
		}
	}

	const fixtureCells=()=>{
		return(
			<Fragment>
				{fixtures.map((f,i)=>
					<TableRow key={f.date}>
						<TSCell>
							<DatePicker
								value={f.date}
								onChange={(v)=>{setFixtureDate(i,v)}}
								inputFormat="yyyy-MM-dd"
								renderInput={(p)=><TextField {...p}/>}
							/>
						</TSCell>
						<TSCell>{f.originalHost}</TSCell>
						<TSCell>
							<Selector
								onChange={(v)=>setFixtureHost(i,v)}
								value={f.host}
								values={players}
							/>
						</TSCell>
						<TSCell>
							<Link href={`/tokenresults/${f.uniqueToken}`}>Link</Link>
						</TSCell>
					</TableRow>
				)}
				<TableRow key="none">
					<TSCell>
						<DatePicker
							value={newFixtureDate}
							onChange={(v)=>{setNewFixtureDate(forceDateInSeason(v))}}
							inputFormat="yyyy-MM-dd"
							renderInput={(p)=><TextField {...p}/>}
						/>
					</TSCell>
					<TSCell>
						<Selector
							onChange={setNewFixtureHost}
							value={newFixtureHost}
							values={players}
						/>
					</TSCell>
					<TSCell>
						<Button variant="contained" onClick={() => addFixture()}>Add</Button>
					</TSCell>
				</TableRow>
			</Fragment>
		)
	}

	const submitFixtures=async ()=>{
		fixtures.forEach(async (f)=>{
			if (f.prevHost!==f.host) {
				await backendPutWithJson(token,dropAdmin,`fixtures/${f.prevDate}`,{
					host:f.host
				});
			}
			if (f.prevDate!==f.date) {
				console.log(f.date);
				await backendPutWithJson(token,dropAdmin,`fixtures/${f.prevDate}`,{
					date:f.date
				});
			}
		});
		forceUpdate();
	}

	const shouldShowSubmit=()=>{
		var should=false;
		fixtures.forEach((f)=>{
			should=should||(f.prevDate!==f.date)||(f.prevHost!==f.host);
		});
		return should;
	}

	return(
		<Stack spacing="0">
			<Subtitle text="Edit Fixtures"/>
			{!activeSeason && <Typography variant="body">There is no active season.</Typography>}
			{activeSeason &&
				<Fragment>
                    <FixtureGenerationRules/>
					<TSTable headings={["Date","Original Venue","Venue","Unique Token"]} sx={{width:{md:865}}}>
						{fixtureCells()}
					</TSTable>
					<Button variant="contained" onClick={submitFixtures}
									disabled={!shouldShowSubmit()} sx={{width:{sm:800}}}>
						Submit
					</Button>
				</Fragment>
			}
		</Stack>
	)
};

export default EditFixturesPage;
